var _style, _g, _g2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "post-error_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 721.7 290.8",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".post-error_svg__st0{fill:#1c3c46}.post-error_svg__st1{fill:#eaeaea}.post-error_svg__st2{fill:#faebb8}.post-error_svg__st3{fill:#656d78}.post-error_svg__st5{fill:#b2b2b2}.post-error_svg__st6{fill:#fff}.post-error_svg__st7{fill:#1b3c47}.post-error_svg__st9{opacity:.15;enable-background:new}.post-error_svg__st17{opacity:.5}.post-error_svg__st19{fill:#f71e1e}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "post-error_svg__Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "post-error_svg__Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M35 263.5L14.9 252.5 14.9 226.6 251.1 226.6 251.1 230.6 18.9 230.6 18.9 250.1 36.9 260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st1",
    d: "M33.3 246.9H44.5V252.70000000000002H33.3zM48.2 246.9H59.400000000000006V252.70000000000002H48.2zM63.2 246.9H74.4V252.70000000000002H63.2zM78.1 246.9H89.3V252.70000000000002H78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st2",
    d: "M93.1 246.9H104.3V252.70000000000002H93.1zM108 246.9H119.2V252.70000000000002H108zM123 246.9H134.2V252.70000000000002H123zM138 246.9H149.2V252.70000000000002H138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st1",
    d: "M30 253.5H155.6V263.2H30zM33.9 263.6H150.8V269.6H33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M157.5,265.5H27.9v-13.7h129.6V265.5z M31.9,261.5h121.6v-5.7H31.9L31.9,261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M152.1 270.7H33.2v-8h118.9V270.7zM35.2 268.7h114.9v-4H35.2L35.2 268.7zM45.6 253.7H32.4v-7.8h13.2V253.7zM34.4 251.7h9.2v-3.8h-9.2V251.7zM60.5 253.7H47.4v-7.8h13.1V253.7zM49.4 251.7h9.2v-3.8h-9.2V251.7zM75.5 253.7H62.3v-7.8h13.2V253.7zM64.3 251.7h9.2v-3.8h-9.2V251.7zM90.4 253.7H77.3v-7.8h13.2V253.7zM79.3 251.7h9.2v-3.8h-9.2L79.3 251.7zM105.4 253.7H92.2v-7.8h13.2V253.7zM94.2 251.7h9.2v-3.8h-9.2L94.2 251.7zM120.3 253.7h-13.1v-7.8h13.2L120.3 253.7zM109.2 251.7h9.2v-3.8h-9.2V251.7zM135.3 253.7h-13.2v-7.8h13.2V253.7zM124.1 251.7h9.2v-3.8h-9.2V251.7zM150.3 253.7h-13.2v-7.8h13.2L150.3 253.7zM139.1 251.7h9.2v-3.8h-9.2L139.1 251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st1",
    d: "M93.6 246.9H104.8V252.70000000000002H93.6zM108.6 246.9H119.8V252.70000000000002H108.6zM123.5 246.9H134.7V252.70000000000002H123.5zM138.5 246.9H149.7V252.70000000000002H138.5zM153.5 246.9H164.7V252.70000000000002H153.5zM168.4 246.9H179.6V252.70000000000002H168.4zM183.4 246.9H194.6V252.70000000000002H183.4zM198.3 246.9H209.5V252.70000000000002H198.3zM90.4 253.5H216V263.2H90.4zM94.3 263.6H211.2V269.6H94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M217.8,265.5H88.2v-13.7h129.6V265.5z M92.2,261.5h121.6v-5.7H92.2V261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M212.5 270.7H93.6v-8h118.9V270.7zM95.6 268.7h114.9v-4H95.6V268.7zM105.9 253.7H92.8v-7.8h13.2L105.9 253.7zM94.8 251.7h9.2v-3.8h-9.2L94.8 251.7zM120.9 253.7h-13.2v-7.8h13.2V253.7zM109.7 251.7h9.2v-3.8h-9.2V251.7zM135.8 253.7h-13.2v-7.8h13.2V253.7zM124.7 251.7h9.2v-3.8h-9.2V251.7zM150.8 253.7h-13.2v-7.8h13.2V253.7zM139.6 251.7h9.2v-3.8h-9.2V251.7zM165.8 253.7h-13.2v-7.8h13.2L165.8 253.7zM154.6 251.7h9.2v-3.8h-9.2L154.6 251.7zM180.7 253.7h-13.2v-7.8h13.1L180.7 253.7zM169.6 251.7h9.1v-3.8h-9.1V251.7zM195.7 253.7h-13.2v-7.8h13.2V253.7zM184.5 251.7h9.2v-3.8h-9.2V251.7zM210.6 253.7h-13.2v-7.8h13.2V253.7zM199.5 251.7h9.2v-3.8h-9.2V251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st3",
    d: "M12.4,272h700.5c4.8,0,8.6,3.9,8.6,8.6v0l0,0c0,4.8-3.9,8.6-8.6,8.6l0,0H12.4c-4.8,0-8.6-3.9-8.6-8.6l0,0l0,0 C3.7,275.9,7.6,272,12.4,272C12.4,272,12.4,272,12.4,272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6,270.8h2.4v17.3h-2.4c-4.8,0-8.6-3.9-8.6-8.6l0,0C2,274.7,5.9,270.8,10.6,270.8 C10.6,270.8,10.6,270.8,10.6,270.8z",
    opacity: 0.45,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M570 267.2L503.8 267.2 503.8 221.5 507.8 221.5 507.8 263.2 570 263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st1",
    d: "M233,173.3h271.7c3.5,0,6.3,2.8,6.3,6.3v73.8c0,3.5-2.8,6.3-6.3,6.3H233c-3.5,0-6.3-2.8-6.3-6.3v-73.8 C226.6,176.1,229.5,173.3,233,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M510.3,179.2V253c0,3.5-1.7,6.3-3.7,6.3h-6.7c2.1,0,3.7-2.8,3.7-6.3v-73.8c0-3.5-1.7-6.3-3.7-6.3h6.7 C508.6,172.9,510.3,175.8,510.3,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M227.8,178.5v73.8c0,3.5,2.8,6.3,6.3,6.3h11.3c-3.5,0-6.3-2.8-6.3-6.3v-73.8c0-3.5,2.8-6.3,6.3-6.3h-11.3 C230.6,172.1,227.8,175,227.8,178.5L227.8,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M283.1 153.5H454.5V172.6H283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M456.5,175.1H281.1V152h175.4V175.1z M285.1,171.1h167.4V156H285.1V171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M248.3 259.2H278.6V268.3H248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M280.6,270.5h-34.3v-13.1h34.3V270.5z M250.3,266.5h26.3v-5.1h-26.3L250.3,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M460.4 259.2H490.7V268.3H460.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M492.7,270.5h-34.3v-13.1h34.3V270.5z M462.4,266.5h26.3v-5.1h-26.3V266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st1",
    d: "M265.9,2.4h205.2c3.4,0,6.2,2.8,6.2,6.2v146.4c0,3.4-2.8,6.2-6.2,6.2H265.9c-3.4,0-6.2-2.8-6.2-6.2V8.6 C259.8,5.1,262.5,2.4,265.9,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M462.8,159.1h9.4c3.4,0,6.1-2.8,6.1-6.1l0,0V6.5c0-3.4-2.7-6.2-6.1-6.2c0,0,0,0,0,0h-9.4 c3.4,0,6.2,2.8,6.2,6.2c0,0,0,0,0,0l0,0v146.4C468.9,156.3,466.2,159.1,462.8,159.1L462.8,159.1L462.8,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M275.6,158.8h-9.4c-3.4,0-6.1-2.8-6.1-6.1l0,0V6.2c0-3.4,2.7-6.2,6.1-6.2c0,0,0,0,0,0h9.4 c-3.4,0-6.2,2.8-6.2,6.2c0,0,0,0,0,0l0,0v146.4C269.5,156,272.2,158.8,275.6,158.8L275.6,158.8L275.6,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M464.9,145H273.3V17.7h191.6V145z M277.3,141h183.6V21.7H277.3V141z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M471.7,162.7H266.5c-4.5,0-8.1-3.7-8.2-8.2V8.2c0-4.5,3.7-8.1,8.2-8.2h205.2c4.5,0,8.1,3.7,8.2,8.2v146.4 C479.8,159.1,476.2,162.7,471.7,162.7z M266.5,4c-2.3,0-4.2,1.9-4.2,4.2c0,0,0,0,0,0l0,0v146.4c0,2.3,1.9,4.2,4.2,4.2l0,0h205.2 c2.3,0,4.2-1.9,4.2-4.2l0,0l0,0V8.2c0-2.3-1.9-4.2-4.2-4.2H266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M259.7,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C261.7,202.9,260.9,203.4,259.7,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M258.3,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C260.3,202.9,259.4,203.4,258.3,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M270.6,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C272.6,202.9,271.7,203.4,270.6,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M269.2,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C271.2,202.9,270.3,203.4,269.2,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M281.5,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C283.5,202.9,282.6,203.4,281.5,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M280,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C282,202.9,281.1,203.4,280,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M292.4,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C294.4,202.9,293.5,203.4,292.4,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M290.9,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C292.9,202.9,292,203.4,290.9,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M303.3,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C305.3,202.9,304.4,203.4,303.3,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M301.8,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C303.8,202.9,302.9,203.4,301.8,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M314.1,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C316.1,202.9,315.3,203.4,314.1,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M312.7,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C314.7,202.9,313.8,203.4,312.7,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M325,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C327,202.9,326.1,203.4,325,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M323.6,203.4c-1.1,0-2-0.5-2-1v-28c0-0.6,0.9-1,2-1s2,0.4,2,1v28C325.6,202.9,324.7,203.4,323.6,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M259.7,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C261.7,258.6,260.9,259.1,259.7,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M258.3,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C260.3,258.6,259.4,259.1,258.3,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M270.6,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C272.6,258.6,271.7,259.1,270.6,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M269.2,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C271.2,258.6,270.3,259.1,269.2,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M281.5,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C283.5,258.6,282.6,259.1,281.5,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M280,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C282,258.6,281.1,259.1,280,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M292.4,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C294.4,258.6,293.5,259.1,292.4,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M290.9,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C292.9,258.6,292,259.1,290.9,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M303.3,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C305.3,258.6,304.4,259.1,303.3,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M301.8,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C303.8,258.6,302.9,259.1,301.8,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M314.1,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C316.1,258.6,315.3,259.1,314.1,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M312.7,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C314.7,258.6,313.8,259.1,312.7,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M325,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C327,258.6,326.1,259.1,325,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M323.6,259.1c-1.1,0-2-0.5-2-1V230c0-0.6,0.9-1,2-1s2,0.4,2,1v28.1C325.6,258.6,324.7,259.1,323.6,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st1",
    d: "M577.7,237.7h26.6c6.4,0,11.5,5.2,11.5,11.5v19.6h-49.6v-19.6C566.2,242.8,571.3,237.7,577.7,237.7 L577.7,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.3,253.2v4.2c0-8.6-7-15.6-15.7-15.6h-18.3c-8.6,0-15.6,7-15.6,15.6v-4.2c0-8.6,7-15.6,15.7-15.7h18.3 C609.3,237.5,616.3,244.5,616.3,253.2z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M566.2 261.2H615.8000000000001V267.5H566.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M617.8,270.8h-53.7v-21.6c0-7.5,6.1-13.5,13.5-13.5h26.5c7.5,0,13.5,6.1,13.5,13.5L617.8,270.8z M568.2,266.8 h45.7v-17.6c0-5.3-4.3-9.5-9.5-9.5h-26.6c-5.3,0-9.5,4.3-9.5,9.5V266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M567.2 254.6H614.7V256.6H567.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M585.3 255.9H596.5999999999999V259.6H585.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M245 226.7c-.8 0-1.5-.7-1.5-1.5v-22.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v22.5C246.5 226 245.8 226.7 245 226.7zM245 238.9c-.8 0-1.5-.7-1.5-1.5v-5.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v5.5C246.5 238.2 245.8 238.9 245 238.9zM297.6 12.4h-22.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h22.5c.8 0 1.5.7 1.5 1.5S298.4 12.4 297.6 12.4zM309.8 12.4h-5.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5.5c.8 0 1.5.7 1.5 1.5S310.6 12.4 309.8 12.4zM42.9 281.5H20.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h22.5c.8 0 1.5.7 1.5 1.5S43.7 281.5 42.9 281.5zM55.1 281.5h-5.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5.5c.8 0 1.5.7 1.5 1.5S55.9 281.5 55.1 281.5zM328.6 152.4h-22.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h22.5c.8 0 1.5.7 1.5 1.5S329.4 152.4 328.6 152.4zM340.8 152.4h-5.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5.5c.8 0 1.5.7 1.5 1.5S341.6 152.4 340.8 152.4zM119 259.4H96.5c-.6 0-1-.4-1-1s.4-1 1-1H119c.6 0 1 .4 1 1S119.6 259.4 119 259.4zM131.2 259.4h-5.5c-.6 0-1-.4-1-1s.4-1 1-1h5.5c.6 0 1 .4 1 1S131.7 259.4 131.2 259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st3",
    d: "M397.1,196.1h74.2c3.8,0,6.9,3.1,6.9,6.9v25.6c0,3.8-3.1,6.9-6.9,6.9h-74.2c-3.8,0-6.9-3.1-6.9-6.9V203 C390.2,199.2,393.3,196.1,397.1,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st9",
    d: "M477.5,202.2v28.4c0,3-2.4,5.5-5.5,5.5h0h-5.9c3,0,5.5-2.5,5.5-5.5v-28.4c0-3-2.5-5.5-5.5-5.5h5.9 C475.1,196.8,477.5,199.2,477.5,202.2L477.5,202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,202.2v28.4c0,3,2.4,5.5,5.5,5.5h0h5.9c-3,0-5.5-2.5-5.5-5.5l0,0l0,0v-28.5c0-3,2.5-5.5,5.5-5.5h-5.9 C393.4,196.8,390.9,199.2,390.9,202.2L390.9,202.2L390.9,202.2z",
    fill: "#858b93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M471.7,238h-74.4c-4.6,0-8.4-3.8-8.4-8.4V204c0-4.6,3.8-8.4,8.4-8.4h74.4c4.6,0,8.4,3.8,8.4,8.4v25.6 C480.1,234.3,476.4,238,471.7,238z M397.4,198.6c-3,0-5.4,2.4-5.4,5.4c0,0,0,0,0,0v25.7c0,3,2.4,5.4,5.4,5.4h74.4 c3,0,5.4-2.4,5.4-5.4V204c0-3-2.4-5.4-5.4-5.4l0,0l0,0L397.4,198.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M399.8 214.2H469.3V219H399.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M422.9 210.6H446.09999999999997V222.7H422.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.9,
    cy: 224,
    r: 5,
    fill: "#a89b76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,224.4c0,2.8-2.2,5-5,5c-0.6,0-1.2-0.1-1.8-0.3c2.6-1,3.8-3.9,2.8-6.5c-0.5-1.3-1.5-2.3-2.8-2.8 c2.6-1,5.5,0.3,6.4,2.9C380.9,223.3,381,223.8,381,224.4L381,224.4z",
    fill: "#93845f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M376.4,230.3c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S379.7,230.3,376.4,230.3L376.4,230.3z M376.4,220.3 c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S378.6,220.3,376.4,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M454.1 225.5H469.3V228.4H454.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "post-error_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.663,
    y1: 78.163,
    x2: 374.077,
    y2: 86.117,
    gradientTransform: "matrix(1 0 0 -1 0 292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc0b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ff796a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1b00"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 376.4,
    cy: 209.9,
    r: 4.6,
    fill: "url(#post-error_svg__SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st5",
    d: "M334.2,173.6h170.3v7.3h-163C337.5,180.9,334.2,177.6,334.2,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M504.7,261.5H232.9c-4.6,0-8.3-3.7-8.3-8.3v-73.8c0-4.6,3.7-8.3,8.3-8.3h271.8c4.6,0,8.3,3.7,8.3,8.3v73.8 C513,257.8,509.3,261.5,504.7,261.5z M232.9,175.1c-2.4,0-4.3,1.9-4.3,4.3v73.8c0,2.4,1.9,4.3,4.3,4.3h271.8 c2.4,0,4.3-1.9,4.3-4.3v-73.8c0-2.4-1.9-4.3-4.3-4.3H232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st9",
    d: "M710.5,271.5h-0.1v-0.6H337.8c0,3.9,3.1,7,7,7h351.8c6,0,10.9,4.9,10.9,10.9c0,0,0,0,0,0h3.3 c4.8,0,8.6-3.9,8.6-8.6v0c0-0.2,0-0.4,0-0.6C719,275,715.1,271.4,710.5,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M711.1,290.8H10.6C4.8,290.8,0,286,0,280.1c0-5.9,4.8-10.6,10.6-10.6h700.5c5.9,0,10.6,4.8,10.6,10.6 C721.7,286,717,290.8,711.1,290.8z M10.6,273.5c-3.7,0-6.6,3-6.6,6.6c0,3.7,3,6.6,6.6,6.6h700.5c3.7,0,6.6-3,6.6-6.6 c0-3.7-3-6.6-6.6-6.6H10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st0",
    d: "M376.4,216.1c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S379.7,216.1,376.4,216.1z M376.4,206.2c-2.2,0-4,1.8-4,4 s1.8,4,4,4s4-1.8,4-4S378.6,206.2,376.4,206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st7",
    d: "M657.3 280.2h60.3c.8 0 1.5.7 1.5 1.5v0c0 .8-.7 1.5-1.5 1.5h-60.3c-.8 0-1.5-.7-1.5-1.5v0C655.8 280.9 656.5 280.2 657.3 280.2zM639.4 280.2h12.3c.8 0 1.5.7 1.5 1.5v0c0 .8-.7 1.5-1.5 1.5h-12.3c-.8 0-1.5-.7-1.5-1.5v0C638 280.9 638.6 280.2 639.4 280.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "post-error_svg__Layer_1-2-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "post-error_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.415,
    y1: 789.095,
    x2: 452.31,
    y2: 789.095,
    gradientTransform: "translate(0 -708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b38d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf4da7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.3,107c0,3.6-2.9,6.5-6.5,6.5l0,0h-132c-3.6-0.4-6.2-3.6-5.8-7.2c0.3-3,2.7-5.4,5.8-5.8h27.8 c3.6-0.4,6.2-3.6,5.8-7.2c-0.3-3-2.7-5.4-5.8-5.8H312c-3.4-1.1-5.4-4.8-4.3-8.2c0.8-2.7,3.3-4.6,6.2-4.6h59.3 c3.6,0.2,6.7-2.5,6.9-6.1c0.2-3.6-2.5-6.7-6.1-6.9c-0.3,0-0.5,0-0.8,0h-30.1c-3.6-0.2-6.3-3.4-6.1-7c0.2-3.3,2.8-5.9,6.1-6.1h73.5 c3.6,0.2,6.3,3.4,6.1,7c-0.2,3.3-2.8,5.9-6.1,6.1h-16.5c-3.6-0.2-6.7,2.5-6.9,6.1c-0.2,3.6,2.5,6.7,6.1,6.9l0,0c0.3,0,0.5,0,0.8,0 h45.7c3.6,0.4,6.2,3.6,5.8,7.2c-0.3,3-2.7,5.4-5.8,5.8H444c-0.6-0.2-1.2-0.3-1.9-0.3h-73.5c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5 l0,0h77.2C449.4,100.5,452.3,103.4,452.3,107z",
    fill: "url(#post-error_svg__SVGID_2_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "post-error_svg__SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.93,
    y1: 763.25,
    x2: 334.27,
    y2: 763.25,
    gradientTransform: "translate(0 -708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b38d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf4da7"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 327.6,
    cy: 55.2,
    r: 6.7,
    fill: "url(#post-error_svg__SVGID_3_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "post-error_svg__SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.85,
    y1: 815.46,
    x2: 304.19,
    y2: 815.46,
    gradientTransform: "translate(0 -708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b38d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf4da7"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 297.5,
    cy: 107.5,
    r: 6.7,
    fill: "url(#post-error_svg__SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "post-error_svg__st17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 350.6,
    cy: 81.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 357.6,
    cy: 78.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M345.4 83.7c-.4 0-.7-.3-.6-.7 0-.4.3-.7.6-.7.3 0 .6.3.6.6l0 0C346 83.4 345.7 83.7 345.4 83.7zM345.4 82.7c-.2 0-.4.2-.4.4 0 .2.2.4.4.4s.4-.2.4-.4c0 0 0 0 0 0l0 0C345.7 82.8 345.6 82.7 345.4 82.7L345.4 82.7zM344.6 79.5l.9.8c.2.2.5-.1.3-.3l-.9-.8C344.7 79 344.4 79.3 344.6 79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M345.5 79.2l-.8.9c-.2.2.1.5.3.3l.8-.9C346 79.3 345.7 79 345.5 79.2L345.5 79.2zM357.6 81l-.8.9c-.2.2.1.5.3.3l.8-.9C358.1 81.1 357.8 80.8 357.6 81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M357.9,81.9L357,81c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C357.8,82.4,358.1,82.1,357.9,81.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 384.7,
    cy: 81.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 391.6,
    cy: 78.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M379.4 83.7c-.4 0-.7-.3-.6-.7 0-.4.4-.6.7-.6.3 0 .5.3.6.6C380.1 83.4 379.8 83.7 379.4 83.7L379.4 83.7zM379.4 82.7c-.2 0-.3.2-.3.4 0 .2.1.3.3.3.2 0 .4-.1.4-.3s-.1-.4-.3-.4C379.5 82.7 379.4 82.7 379.4 82.7zM378.7 79.5l.9.8c.2.2.5-.1.3-.3l-.9-.8C378.8 79 378.5 79.3 378.7 79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M379.5 79.2l-.8.9c-.2.2.1.5.3.3l.8-.9C380 79.3 379.7 79 379.5 79.2zM391.6 81l-.8.9c-.2.2.1.5.3.3l.8-.9C392.2 81.1 391.8 80.8 391.6 81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M392,81.9l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C391.9,82.4,392.2,82.1,392,81.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 437.7,
    cy: 81.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 444.7,
    cy: 78.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M432.5 83.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.4 0 .6.3.6.7C433.1 83.4 432.9 83.7 432.5 83.7zM432.5 82.7c-.2 0-.4.2-.4.4 0 .2.2.4.4.4.2 0 .4-.2.4-.4 0 0 0 0 0 0C432.8 82.8 432.7 82.7 432.5 82.7zM431.7 79.5l.9.8c.2.2.5-.1.3-.3l-.9-.8C431.8 79 431.5 79.3 431.7 79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M432.6 79.2l-.8.9c-.2.2.1.5.3.3l.8-.9C433.1 79.3 432.8 79 432.6 79.2zM444.7 81l-.8.9c-.2.2.1.5.3.3l.8-.9C445.2 81.1 444.9 80.8 444.7 81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M445.1,81.9l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C445,82.4,445.3,82.1,445.1,81.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 320,
    cy: 81.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 327,
    cy: 78.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M314.7 83.7c-.4 0-.7-.3-.6-.7 0-.4.3-.7.6-.7.4 0 .7.3.7.7l0 0C315.4 83.4 315.1 83.7 314.7 83.7zM314.7 82.7c-.2 0-.3.2-.3.4 0 .2.1.3.3.3.2 0 .4-.2.4-.4l0 0C315.1 82.8 314.9 82.7 314.7 82.7L314.7 82.7zM314 79.5l.9.8c.2.2.5-.1.3-.3l-.9-.8C314.1 79 313.8 79.3 314 79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M314.8 79.2l-.8.9c-.2.2.1.5.3.3l.8-.9C315.3 79.3 315 79 314.8 79.2zM327 81l-.8.9c-.1.1-.1.2 0 .3s.2.1.3 0l0 0 .8-.9C327.5 81.1 327.1 80.8 327 81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M327.3,81.9l-0.9-0.9c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C327.2,82.4,327.5,82.1,327.3,81.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "post-error_svg__st17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 348.4,
    cy: 55.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 355.3,
    cy: 53.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M343.1 57.8c-.4 0-.7-.3-.7-.6 0-.4.3-.7.6-.7.4 0 .7.3.7.6 0 0 0 0 0 0l0 0C343.8 57.5 343.5 57.8 343.1 57.8 343.1 57.8 343.1 57.8 343.1 57.8zM343.1 56.8c-.2 0-.4.1-.4.3 0 0 0 0 0 0 0 .2.2.3.4.3.2 0 .3-.1.3-.3l0 0C343.5 57 343.3 56.8 343.1 56.8 343.1 56.8 343.1 56.8 343.1 56.8L343.1 56.8zM342.3 53.7l.9.8c.2.2.5-.1.3-.3l-.9-.8C342.5 53.2 342.1 53.5 342.3 53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M343.2 53.4l-.8.9c-.2.2.1.5.3.3l.8-.9C343.7 53.5 343.4 53.2 343.2 53.4zM355.3 55.2l-.8.9c-.2.2.1.5.3.3l.8-.9C355.9 55.3 355.5 55 355.3 55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M355.7,56l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C355.6,56.5,355.9,56.2,355.7,56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 376.5,
    cy: 55.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 383.4,
    cy: 53.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M371.2 57.8c-.4 0-.6-.3-.6-.7 0-.4.3-.7.6-.7.4 0 .7.3.7.7C371.8 57.6 371.6 57.9 371.2 57.8zM371.2 56.8c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0 0 0 0 0 0C371.5 57 371.4 56.9 371.2 56.8zM370.4 53.7l.9.8c.2.2.5-.1.3-.3l-.9-.8C370.5 53.2 370.2 53.5 370.4 53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M371.3 53.4l-.8.9c-.2.2.1.5.3.3l.8-.9C371.8 53.5 371.5 53.2 371.3 53.4zM383.4 55.2l-.8.9c-.2.2.1.5.3.3l.8-.9C383.9 55.3 383.6 55 383.4 55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M383.8,56l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C383.7,56.5,384,56.2,383.8,56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 409.9,
    cy: 55.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 416.9,
    cy: 53.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M404.7 57.8c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.4 0 .7.3.6.7C405.3 57.6 405 57.8 404.7 57.8zM404.7 56.8c-.2 0-.4.1-.4.3 0 .2.1.4.3.4 0 0 .1 0 .1 0 .2 0 .3-.2.3-.4C404.9 57 404.8 56.9 404.7 56.8zM403.9 53.7l.9.8c.2.2.5-.1.3-.3l-.9-.8C404 53.2 403.7 53.5 403.9 53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M404.8 53.4l-.8.9c-.2.2.1.5.3.3l.8-.9C405.3 53.5 405 53.2 404.8 53.4zM416.9 55.2l-.8.9c-.2.2.1.5.3.3l.8-.9C417.4 55.3 417.1 55 416.9 55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M417.2,56l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C417.1,56.5,417.5,56.2,417.2,56z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "post-error_svg__st17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 332.2,
    cy: 107.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 339.1,
    cy: 105.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M326.9 110.1c-.4 0-.7-.3-.7-.7v0c0-.4.4-.6.7-.6.3 0 .5.3.6.6l0 0C327.6 109.8 327.3 110.1 326.9 110.1zM326.9 109.1c-.2 0-.4.2-.4.4 0 .2.2.4.4.4.2 0 .4-.2.4-.4 0 0 0 0 0 0l0 0C327.3 109.2 327.1 109.1 326.9 109.1L326.9 109.1zM326.2 105.9l.9.8c.2.2.5-.1.3-.3l-.9-.8C326.3 105.4 326 105.8 326.2 105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M327 105.6l-.8.9c-.2.2.1.5.3.3l.8-.9C327.5 105.7 327.2 105.4 327 105.6zM339.1 107.4l-.8.9c-.2.2.1.5.3.3l.8-.9C339.7 107.5 339.4 107.2 339.1 107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M339.5,108.2l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C339.4,108.8,339.7,108.4,339.5,108.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 376.5,
    cy: 107.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 383.4,
    cy: 105.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M371.2 110.1c-.4 0-.7-.3-.6-.7 0-.4.3-.7.6-.7.4 0 .7.3.7.7C371.8 109.8 371.6 110.1 371.2 110.1zM371.2 109.1c-.2 0-.3.2-.3.4 0 .2.1.3.3.3.2 0 .4-.1.4-.3s-.1-.4-.3-.4C371.3 109.1 371.2 109.1 371.2 109.1zM370.4 105.9l.9.8c.2.2.5-.1.3-.3l-.9-.8C370.5 105.4 370.2 105.8 370.4 105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M371.3 105.6l-.8.9c-.2.2.1.5.3.3l.8-.9C371.8 105.7 371.5 105.4 371.3 105.6zM383.4 107.4l-.8.9c-.2.2.1.5.3.3l.8-.9C383.9 107.5 383.6 107.2 383.4 107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M383.8,108.2l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C383.7,108.8,384,108.4,383.8,108.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 429.8,
    cy: 107.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "post-error_svg__st6",
    cx: 436.8,
    cy: 105.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M424.5 110.1c-.4 0-.7-.3-.6-.7 0-.4.3-.7.6-.7.4 0 .7.3.7.7C425.2 109.8 424.9 110.1 424.5 110.1zM424.5 109.1c-.2 0-.3.2-.3.4 0 .2.1.3.3.3.2 0 .4-.1.4-.3s-.1-.4-.3-.4C424.6 109.1 424.6 109.1 424.5 109.1zM423.8 105.9l.9.8c.2.2.5-.1.3-.3l-.9-.8C423.9 105.4 423.6 105.8 423.8 105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M424.6 105.6l-.8.9c-.2.2.1.5.3.3l.8-.9C425.1 105.7 424.8 105.4 424.6 105.6zM436.8 107.4l-.8.9c-.1.1-.1.2 0 .3s.2.1.3 0l.8-.9C437.3 107.5 437 107.2 436.8 107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st6",
    d: "M437.1,108.2l-0.9-0.8c-0.2-0.2-0.5,0.1-0.3,0.3l0.9,0.8C437,108.8,437.3,108.4,437.1,108.2z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-80.078 382.338 78.989)",
    opacity: 0.35,
    fill: "#abb5b7",
    d: "M351.2 16.1H413.5V141.9H351.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-80.078 381.026 76.288)",
    className: "post-error_svg__st6",
    d: "M349.5 12.7H412.4V139.79999999999998H349.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "post-error_svg__st19",
    d: "M347.2 65.9l-6.2-.8-.4 3.3 5.8.8-.6 4.4-5.8-.8-.5 3.4 6.2.8-.6 4.4L333.8 80l2.7-19.9 11.3 1.5L347.2 65.9zM365.4 84.2l-6.5-.9L355 75l-1 7.7-5.2-.7 2.7-19.9 8.1 1.1c1.1.1 2.1.4 2.8.9.8.4 1.4 1 1.9 1.6.5.6.8 1.3 1 2.1.2.8.2 1.6.1 2.4-.2 1.5-.7 2.7-1.6 3.5s-2 1.3-3.5 1.5L365.4 84.2zM355.5 71.7l1 .1c1 .1 1.8 0 2.4-.3.6-.4 1-.9 1.1-1.7.1-.8-.1-1.4-.6-1.9s-1.2-.8-2.3-.9l-1-.1L355.5 71.7zM384.2 86.7l-6.5-.9-3.9-8.3-1 7.7-5.2-.7 2.7-19.9 8.1 1.1c1.1.1 2.1.4 2.8.9.8.4 1.4 1 1.9 1.6.5.6.8 1.3 1 2.1.2.8.2 1.6.1 2.4-.2 1.5-.7 2.7-1.6 3.5s-2 1.3-3.5 1.5L384.2 86.7zM374.3 74.2l1 .1c1 .1 1.8 0 2.4-.3.6-.4 1-.9 1.1-1.7.1-.8-.1-1.4-.6-1.9-.5-.5-1.2-.8-2.3-.9l-1-.1L374.3 74.2zM386.4 76.9c.2-1.5.7-2.8 1.4-4 .7-1.2 1.6-2.2 2.7-3 1.1-.8 2.4-1.4 3.8-1.8 1.4-.4 2.9-.4 4.6-.2 1.6.2 3.1.7 4.3 1.4 1.3.7 2.4 1.6 3.2 2.7.9 1.1 1.5 2.3 1.8 3.7s.5 2.8.3 4.2c-.2 1.5-.7 2.8-1.4 4-.7 1.2-1.6 2.2-2.7 3-1.1.8-2.4 1.4-3.8 1.8-1.4.4-2.9.4-4.6.2-1.6-.2-3.1-.7-4.3-1.4-1.3-.7-2.3-1.6-3.2-2.7-.8-1.1-1.5-2.3-1.8-3.7C386.3 79.8 386.2 78.3 386.4 76.9zM391.8 77.6c-.1.8-.1 1.5.2 2.3.2.7.5 1.3 1 1.9.4.6 1 1 1.6 1.4s1.3.6 2.1.7c.8.1 1.5.1 2.2-.1.7-.2 1.4-.5 2-.9.6-.4 1.1-1 1.5-1.6s.6-1.3.7-2.1c.1-.8.1-1.5-.2-2.3-.2-.7-.5-1.3-1-1.9-.5-.6-1-1-1.6-1.4-.6-.4-1.3-.6-2.1-.7-.8-.1-1.5-.1-2.2.1-.7.2-1.4.5-1.9.9s-1.1 1-1.4 1.6C392.2 76.1 391.9 76.8 391.8 77.6zM427 92.4l-6.5-.9-3.9-8.3-1 7.7-5.2-.7 2.7-19.9 8.1 1.1c1.1.1 2.1.4 2.8.9.8.4 1.4 1 1.9 1.6.5.6.8 1.3 1 2.1.2.8.2 1.6.1 2.4-.2 1.5-.7 2.7-1.6 3.5-.9.8-2 1.3-3.5 1.5L427 92.4zM417.1 79.9l1 .1c1 .1 1.8 0 2.4-.3.6-.4 1-.9 1.1-1.7.1-.8-.1-1.4-.6-1.9-.5-.5-1.2-.8-2.3-.9l-1-.1L417.1 79.9z"
  })));
}

export default SvgPostError;